import React from "react";
import PropTypes from "prop-types";
import styled from "@emotion/styled";

// style rules
import { Sizes } from "../../styles";

const SidePanelSponsors = ({ sponsors }) => {
	const RenderedSponsors = sponsors.map((sponsor) => {
		let key = `${sponsor.title}-${sponsor.id}`;
		return (
			<Sponsor key={key} src={sponsor.image} alt={`${sponsor.title} logo`} />
		);
	});

	return (
		<SponsorsContainer>
			<Title>Sponsors</Title>
			<SponsorsWrapper>{RenderedSponsors}</SponsorsWrapper>
		</SponsorsContainer>
	);
};

export default SidePanelSponsors;

SidePanelSponsors.propTypes = {
	sponsors: PropTypes.array,
};

const SponsorsContainer = styled.div`
	padding-top: 6rem;
`;

const Title = styled.h3`
	font-size: 3rem;
	line-height: 3.6rem;
	letter-spacing: -0.004em;
	text-align: center;
`;

const SponsorsWrapper = styled.div`
	padding-top: 2.4rem;
	display: flex;
	gap: 3.5rem;
	align-items: center;
	justify-content: center;
	flex-wrap: wrap;

	@media only screen and (min-width: ${Sizes.screens.large}) {
		gap: 7.4rem;
	}
`;

const Sponsor = styled.img`
	height: 62px;
	width: auto;
`;
